import styled, { css } from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { FlexContainer, FlexContainerCentered } from "BaseComponents/Flex";

export const SearchFieldWrapper = styled(FlexContainer)`
	flex-grow: 0;
`;

export const SearchFieldInnerWrapper = styled(FlexContainerCentered)`
	display: block;
	& {
		padding: 1rem 0;
	}
`;
export const SearchButton = styled.button`
	border: none;

	input {
		color: blue;
	}
	background: transparent;
	cursor: pointer;
`;
export const InputWrapper = styled.div`
	${media.greaterThan(breakpoints.mobile)`
	width: 250px;

`}
	background: white;

	width: 100%;
	border-radius: 50px;
	padding: 5px;
	height: 40px;
	align-items: center;
	justify-content: flex-start;
	display: flex;
	border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
`;
export const Icon = styled.i`
	color: ${({ theme }) => theme.colors.primary};

	font-size: 20px;
`;
export const Input = styled.input`
	height: 100%;
	/* padding: 10px; */
	border: none;
	background: transparent;
	height: auto;
	font-size: 16px;
	color: black;
	font-family: ${({ theme }) => theme.font};
	${media.greaterThan(breakpoints.mobile)`
	font-size: 18px;
	
	`}

	&:focus {
		outline: none;
	}
`;
